<template>
  <button
    :class="[
      isSelected
        ? ' tw--mt-px tw-border-t-2 tw-border-primary tw-pt-2.5 sm:tw-pt-3 tw-px-4 tw-inline-flex tw-items-center tw-text-sm tw-leading-5 tw-font-normal tw-text-primary focus:tw-outline-none focus:tw-text-primary focus:tw-border-primary tw-transition tw-ease-in-out tw-duration-150'
        : ' tw--mt-px tw-border-t-2 tw-border-transparent tw-pt-2.5 sm:tw-pt-3 tw-px-4 tw-inline-flex tw-items-center tw-text-sm tw-leading-5 tw-font-normal tw-text-gray-500 hover:tw-text-gray-700 hover:tw-border-gray-300 focus:tw-outline-none focus:tw-text-gray-700 focus:tw-border-gray-400 tw-transition tw-ease-in-out tw-duration-150',
    ]"
    @click="$emit('click')"
  >
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    isSelected: Boolean,
  },
};
</script>
